"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _dompurify = _interopRequireDefault(require("dompurify"));

var _core = require("@material-ui/core");

var _CardContent = _interopRequireDefault(require("@material-ui/core/CardContent"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _moment = _interopRequireDefault(require("moment"));

var _useTimer = require("./useTimer");

var _FeedbackProvider = require("./FeedbackProvider");

var _GroupRatingFeedback = _interopRequireDefault(require("./GroupRatingFeedback"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _LiveTickerMessage = _interopRequireDefault(require("./LiveTickerMessage.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var LiveTickerRatingGroupFeedback = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2["default"])(LiveTickerRatingGroupFeedback, _React$Component);

  var _super = _createSuper(LiveTickerRatingGroupFeedback);

  function LiveTickerRatingGroupFeedback(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, LiveTickerRatingGroupFeedback);
    _this = _super.call(this, props);
    _this.state = {
      quotedMessage: null
    };
    return _this;
  }

  (0, _createClass2["default"])(LiveTickerRatingGroupFeedback, [{
    key: "render",
    value: function render() {
      var message = _dompurify["default"].sanitize(this.props.message);

      var _this$props = this.props,
          messages = _this$props.messages,
          group = _this$props.group;
      return /*#__PURE__*/_react["default"].createElement(_core.Card, {
        className: _LiveTickerMessage["default"].outer,
        key: "entry_".concat(message.id),
        id: message.id,
        style: this.props.isHidden ? {
          padding: 0,
          margin: 0,
          maxHeight: 0
        } : {
          padding: '7px',
          margin: '10px 0',
          maxHeight: '9999px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '20%',
          display: 'inline-block',
          verticalAlign: 'top',
          padding: 0
        }
      }, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].author : _LiveTickerMessage["default"].authorMobile,
        color: "textSecondary",
        gutterBottom: true
      }, this.props.author), /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].date : _LiveTickerMessage["default"].dateMobile,
        color: "textSecondary",
        gutterBottom: true
      }, (0, _moment["default"])(this.props.dateCreated).format('DD.MM.YYYY HH:mm'))), /*#__PURE__*/_react["default"].createElement(_CardContent["default"], {
        style: {
          width: '80%',
          display: 'inline-block',
          padding: 0,
          paddingLeft: 10,
          verticalAlign: 'top'
        }
      }, this.props.imageLink ? /*#__PURE__*/_react["default"].createElement("img", {
        style: {
          width: '100%',
          height: 'auto',
          display: 'block',
          position: 'relative',
          paddingBottom: '8px'
        },
        src: this.props.imageLink
      }) : null, /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
        className: _DeviceInfoHelper["default"].isBrowser() ? _LiveTickerMessage["default"].message : _LiveTickerMessage["default"].messageMobile,
        color: "textSecondary",
        gutterBottom: true,
        dangerouslySetInnerHTML: {
          __html: message
        }
      }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_FeedbackProvider.FeedbackContext.Consumer, null, function (feedbacks) {
        return /*#__PURE__*/_react["default"].createElement(_GroupRatingFeedback["default"], {
          feedbacks: feedbacks,
          messages: messages,
          group: group
        });
      }))));
    }
  }]);
  return LiveTickerRatingGroupFeedback;
}(_react["default"].Component);

LiveTickerRatingGroupFeedback.propTypes = {
  id: _propTypes["default"].string,
  userId: _propTypes["default"].string,
  key: _propTypes["default"].string,
  message: _propTypes["default"].string,
  dateCreated: _propTypes["default"].string,
  dateEdited: _propTypes["default"].string,
  isLatest: _propTypes["default"].bool,
  author: _propTypes["default"].string,
  imageLink: _propTypes["default"].string,
  isHidden: _propTypes["default"].bool,
  data: _propTypes["default"].object,
  duration: _propTypes["default"].string,
  setTimer: _propTypes["default"].func,
  completed: _propTypes["default"].number,
  active: _propTypes["default"].bool,
  messages: _propTypes["default"].array,
  group: _propTypes["default"].string
};
LiveTickerRatingGroupFeedback.defaultProps = {
  isLatest: false,
  isExpert: false
};

var _default = (0, _useTimer.withTimer)(LiveTickerRatingGroupFeedback);

exports["default"] = _default;